import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { query_client } from './lib/query-client';
import App from './App';
import './index.css';

const root_el = document.getElementById('root');
if (!root_el) throw new Error('#root element not found');

createRoot(root_el).render(
  <StrictMode>
    <QueryClientProvider client={query_client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
